import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import type { Progresso } from '../types/Progresso';
import { buscaDoFunil, FILTRO_FUNIL } from './funil';

const NUMEROS = ['naCampanha', 'convidados', 'acessaram', 'responderam'] as const;

/** Os quatro números do funil em tamanho menor, cada um um link à lista filtrada (spec 29 R14, R21). */
export function FunilCompacto({
  campanhaId,
  progresso,
}: {
  campanhaId: string;
  progresso: Pick<Progresso, (typeof NUMEROS)[number] | 'fase'>;
}) {
  const { t } = useTranslation('campanhas');
  return (
    <div className="grid grid-cols-2 gap-x-6 gap-y-2 sm:flex sm:flex-wrap" data-funil-compacto>
      {NUMEROS.map((n) => (
        <Link
          key={n}
          to={`/campanhas/${campanhaId}${buscaDoFunil(FILTRO_FUNIL[n])}`}
          className="flex flex-col rounded-md hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus"
        >
          <span className="text-xl font-semibold text-foreground">{progresso[n]}</span>
          <span className="text-xs text-foreground-muted">{t(`funil.${n}`)}</span>
        </Link>
      ))}
    </div>
  );
}
